import { InjectionToken } from '@angular/core';

export const CURRENCY_NUMBER_MULTIPLYER = new InjectionToken<number>('MyNumberToken', {
  providedIn: 'root',
  factory: () => 1,
});
export type IIdPreficSufix = {
  prefix: string;
  sufix: Array<{ name: string; sign: string; needsCompatibility?: boolean }>;
};
export const ID_PREFIX_SUFIX = new InjectionToken<IIdPreficSufix>('IdPrefixSufix');

export const WINDOW = new InjectionToken<Window>('Global window object', {
  factory: () => window,
});
